import { HttpHeaders } from '@angular/common/http';

export const OLD_RESULT = 'old_result';
export const ITEM_RESULT = 'item_result';
export const USER_DETAIL = 'user_detail';
export const CLAIM_NO = 'claim_no';
export const LANGUAGES = ["th", "en"];
export const CURRENT_LANGUAGES = 'currentLanguage';
export const CURRENT_STEP = 'currentStep';
export const ID_STEP1 = 'idStep1';
export const STP_RESPONE = 'stpRespone';

export const SMARTCLAIM_TOKEN_KEY = 'smartclaim_token';
export const ADMIN_TOKEN_KEY = 'admin_token';

export const CONTENT_TYPE = 'application/json';

export const HTTP_OPTIONS_SMARTCLAIM = {
    headers: new HttpHeaders({
        'configToken': SMARTCLAIM_TOKEN_KEY,
    })
};

export const HTTP_OPTIONS_ADMIN = {
    headers: new HttpHeaders({
        'configToken': ADMIN_TOKEN_KEY,
    })
};
